import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatSelectionListChange } from '@angular/material/list';

import { RDS_DATA_DICTIONARY_ALL_COLUMNS, RdsDataDictionaryTableColumn } from './data-dictionary-table-column.model';

export class RdsColumnToggleEvent {
  /**
   * @param show Whether the column should be shown
   * @param column The column to show or hide
   */
  constructor(public show: boolean, public column: RdsDataDictionaryTableColumn) {}
}

// ERROR Error: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked.
// Previous value: 'aria-expanded: true'.Current value: 'aria-expanded: null'.
// https://github.com/angular/components/issues/14440
@Component({
  selector: 'rds-column-toggle',
  template: `
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>{{ menuButtonIcon }}</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <mat-selection-list
        (click)="$event.stopPropagation()"
        [ngModel]="selectedColumns"
        [compareWith]="_compareWithColumns"
        (selectionChange)="handleColumnsSelectionChange($event)"
      >
        <mat-list-option *ngFor="let column of columnMenuOptions" role="menuitemcheckbox" [value]="column">
          {{ column.label }}
        </mat-list-option>
      </mat-selection-list>
    </mat-menu>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class RdsColumnToggleComponent {
  /**
   * All the column options to choose from. Defaults to:
   * `RDS_DATA_DICTIONARY_ALL_COLUMNS.slice()`
   */
  @Input() allColumnOptions: Array<RdsDataDictionaryTableColumn> = RDS_DATA_DICTIONARY_ALL_COLUMNS.slice();
  /** Icon to use for the menu button */
  @Input() menuButtonIcon = 'more_vert';
  /**
   * The selected columns. Defaults to:
   * `RDS_DATA_DICTIONARY_ALL_COLUMNS.slice(0, 5)`
   */
  @Input() selectedColumns: Array<RdsDataDictionaryTableColumn> = RDS_DATA_DICTIONARY_ALL_COLUMNS.slice(0, 5);

  /** Emitted when a column is toggled on or off */
  @Output() columnToggle = new EventEmitter<RdsColumnToggleEvent>();

  /** The columns to toggle in the menu. Exclude the selected column. */
  get columnMenuOptions(): Array<RdsDataDictionaryTableColumn> {
    return this.allColumnOptions.filter(c => c.property !== 'selected');
  }

  handleColumnsSelectionChange(event: MatSelectionListChange) {
    this.columnToggle.emit(new RdsColumnToggleEvent(event.option.selected, event.option.value));
  }

  _compareWithColumns(o1: RdsDataDictionaryTableColumn, o2: RdsDataDictionaryTableColumn) {
    if (!o1 || !o2) {
      return false;
    }
    return o1.property === o2.property;
  }
}
